import React, { useRef, useState } from 'react';
import { useMouseHovered } from 'react-use';
import moment from 'moment-timezone';

import { PORTAL_COLORS } from 'interfaces/common-ui-types';
import { EndSpacer } from './EndSpacer';
import { IRosterCustomer } from '../../types';
import { AddBookingPopover, OnAddBooking } from './add-booking-popover';
import { rosterConfig } from '../../roster-config';

const { TIMELINE_ROW_HEIGHT, TIMELINE_HOUR_BLOCK_WIDTH } = rosterConfig;

interface TimelineRowProps {
  customer: IRosterCustomer; // <- Not too happy with this, as it makes it less generic. to fix later.
  currentDate?: Date;
  items?: JSX.Element | JSX.Element[];
  rowWidth: number;
  rowHeight?: number; // Row height can passed in to overwrite the default TIMELINE_ROW_HEIGHT
  hasAddAction?: boolean;
  onAddBooking: OnAddBooking;
}

export function TimelineRow({
  customer,
  currentDate,
  items,
  rowWidth,
  rowHeight = TIMELINE_ROW_HEIGHT,
  hasAddAction = false,
  onAddBooking,
}: TimelineRowProps) {
  const rowRef = useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = useState(false);
  const bgColor = rosterConfig.backgroundColor;
  // const rowWidth = HOUR_BLOCK_WIDTH * _.size(hours); // For later use if we decide to allow users to change the hours displayed
  const { elX: currentX } = useMouseHovered(rowRef, {
    bound: true,
    whenHovered: true,
  }); // elX = position of mouse cursor within the div element.
  const roundedX = Math.floor(currentX / 60) * 60 + 4; // round down elX to nearest 60
  const offsetX = roundedX; // Offset for the button. If the dialog's open, use the buffered position to prevent it from jumping around.

  const handleAddBooking = async (pos: number) => {
    const factor = 60 / TIMELINE_HOUR_BLOCK_WIDTH;
    const minutes = factor * (pos - 4); // -4 to account for the offset // NOTE THIS WILL NEED ADJUSTMENT BASED ON HOUR BLOCK WIDTH
    const targetDate = moment(currentDate).startOf('day').add(minutes, 'minutes').toDate(); // add minutes to current date
    const { customerId } = customer;
    await onAddBooking({ customerId, startDateTime: targetDate });
  };

  return (
    <div className='flex-row'>
      <div
        className={'position-relative bordered-right bordered-bottom'}
        style={{ height: rowHeight, minWidth: `${rowWidth}px`, maxWidth: `${rowWidth}px`, backgroundColor: bgColor }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        ref={rowRef}
      >
        {hasAddAction && isHovered && (
          <AddBookingPopover offsetX={offsetX} onAddBooking={() => handleAddBooking(roundedX)} />
        )}
        {items}
      </div>
      <EndSpacer height={rowHeight} />
    </div>
  );
}
